module.exports = __webpack_public_path__ + "static/media/girl-24.1fb26edf.svg";